module.exports = __webpack_public_path__ + "static/media/996708.139ab8f4.png";